import { render, staticRenderFns } from "./LiyouMan.vue?vue&type=template&id=0ea03857&scoped=true&"
import script from "./LiyouMan.vue?vue&type=script&lang=js&"
export * from "./LiyouMan.vue?vue&type=script&lang=js&"
import style0 from "./LiyouMan.vue?vue&type=style&index=0&id=0ea03857&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea03857",
  null
  
)

export default component.exports